"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15.848 16.836a1.07 1.07 0 0 1 .078 1.507 1.062 1.062 0 0 1-1.504.078l-6.27-5.672a1.07 1.07 0 0 1 .002-1.587l6.216-5.583a1.063 1.063 0 0 1 1.504.083 1.07 1.07 0 0 1-.083 1.507l-4.944 4.44a.473.473 0 0 0 0 .703l5.002 4.524Z"
})), "0 0 24 24", "ChevronBackward");